import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Notification as ManorNotification } from '@comparethemarketau/manor-notification';
import { get, getRulesFromState, rulesCache  } from 'ctm-util-functions';
import { connect } from 'react-redux';
import { DynamicComponent } from '../dynamic_component/dynamic_component';

/**
 * Render Notification Widget
 * @param {String} content StateKey for product Disclosures list/map
 * @param {Boolean} convertContentStringToHtmlNode flag to Convert the content from a string to a html node if required
 * @returns {Node} Notification component
 */

class _Notification extends Component {

    render() {
        const { convertContentStrToHtmlNode, content } = this.props;
        const contentCoverted = (convertContentStrToHtmlNode && content)
            ? <>{ReactHtmlParser(content)}</>
            : content;
        return (
            <DynamicComponent component={<ManorNotification { ...this.props } content={ contentCoverted } />} />
        );
    }

}

_Notification.propTypes = {
    content: PropTypes.string,
    convertContentStrToHtmlNode: PropTypes.bool,
    icon: PropTypes.bool,
    contentOverride: PropTypes.string,
    rules: PropTypes.object
};

const mapStateToProps = (state, props) => {
    const rules = getRulesFromState(state, props);
    if (!Object.keys(rules).length) {
        return;
    }

    let content = null;
    // Override content when content result rule met
    if (get(rules, 'content.result', false)) {
        const contentRule = rulesCache.getElementRuleForId(rules.content.id);
        content = contentRule.props.contentOverride;
    } else if (state.hasOwnProperty('content')) {
        content = state.content;
    } else {
        return;
    }
    /* eslint-disable consistent-return */
    return {
        content,
        rules
    };
};

const Notification = connect(mapStateToProps)(_Notification);

export { _Notification, Notification };
